import React from "react";

import { useAuthContext } from "@main/context/Auth/Auth.context";
import { RoutePaths } from "@main/router/config/routePaths";
import { Navigate, useLocation } from "react-router-dom";

export interface ReturnUrlState {
  returnUrl?: string;
}

interface Props {
  children: JSX.Element;
}

export default function AuthProtected({ children }: Props) {
  const { userToken } = useAuthContext();
  const location = useLocation();

  if (!userToken) {
    const returnUrl = location.pathname + location.search;

    return (
      <Navigate
        to={RoutePaths.SIGNIN}
        state={{ returnUrl: returnUrl } as ReturnUrlState}
      />
    );
  }

  return <>{children}</>;
}
